"use client";

import { authForgotPassword } from "@/entities";
import { useMutation } from "@tanstack/react-query";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";

export function ForgotPasswordPage() {
  const router = useRouter();
  const [success, setSuccess] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const forgotPasswordMutation = useMutation({
    mutationFn: authForgotPassword,
    onSuccess: () => {
      setSuccess(true);
    },
    onError: (e: any) => {
      toast.error(`에러(${e.message})가 발생했습니다. 다시 시도해 주세요.`);
    },
  });

  const onSubmit = async (data: any) => {
    if (forgotPasswordMutation.isPending) return;
    await forgotPasswordMutation.mutateAsync(data);
  };

  return (
    <>
      {success ? (
        <div className="login login-v1">
          <div className="login-container">
            <div className="login-header">
              <div className="brand">
                <div className="d-flex align-items-center">이메일 확인</div>
                <small>비밀번호 재설정 안내가 전송되었습니다.</small>
              </div>
              <div className="icon">
                <i className="fa fa-envelope"></i>
              </div>
            </div>
            <div className="login-body">
              <div className="login-content fs-13px">
                이메일과 비밀번호를 사용하여 등록하신 경우, 비밀번호 재설정
                <br />
                이메일을 받으시게 됩니다.
              </div>
            </div>
            <div id="footer" className="app-footer text-center">
              &copy; 2025 wezoncoop. All Right Reserved
            </div>
          </div>
        </div>
      ) : (
        <div className="login login-v1">
          <div className="login-container">
            <div className="login-header">
              <div className="brand">
                <div className="d-flex align-items-center">비밀번호 재설정</div>
                <small>
                  이메일을 입력하시면 비밀번호 재설정 링크를 보내드립니다.
                </small>
              </div>
              <div className="icon">
                <i className="fa fa-cog"></i>
              </div>
            </div>
            <div className="login-body">
              <div className="login-content fs-13px">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Controller
                    name="email"
                    control={control}
                    rules={{
                      validate: (value) => {
                        const noEngRule =
                          /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;
                        return !noEngRule.test(value)
                          ? "이메일 형식으로 입력해주세요."
                          : undefined;
                      },
                    }}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <>
                        <div className="mb-3">
                          <label className="mb-2" htmlFor="email">
                            이메일 <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            id="email"
                            title="이메일을 입력해주세요."
                            placeholder="이메일을 입력해주세요."
                            className="form-control fs-13px"
                            onChange={onChange}
                            onBlur={onBlur}
                            value={value || ""}
                          />
                          {errors.email && (
                            <span className="text-red errorText">
                              {errors.email.message as string}
                            </span>
                          )}
                        </div>
                      </>
                    )}
                  />

                  <div className="login-buttons mb-15px">
                    <button
                      type="submit"
                      className="btn h-45px btn-theme d-block w-100 btn-lg"
                      disabled={forgotPasswordMutation.isPending}
                    >
                      재설정 이메일 보내기
                    </button>
                  </div>

                  <div className="text-center">
                    이미 계정이 있으신가요?{" "}
                    <Link
                      href="/auth/login"
                      className="text-white text-decoration-none fw-bold"
                    >
                      로그인
                    </Link>
                  </div>
                </form>
              </div>
            </div>
            <div id="footer" className="app-footer text-center">
              &copy; 2025 wezoncoop. All Right Reserved
            </div>
          </div>
        </div>
      )}
    </>
  );
}
